module.exports = __webpack_public_path__ + "img/gallery-image-36.d1db35c1.jpg";